var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegularGroupIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160px",
    height: "88px",
    viewBox: "0 0 160 88",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D3E81C9C-F058-4DE1-9EAD-24EBAB28F1CB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groups",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groups-/-My-groups-/-Create-a-group-(For-Creater)",
    transform: "translate(-464.000000, -870.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pop-up"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(200.000000, 347.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "list"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dialog"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groups-list",
    transform: "translate(63.000000, 154.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Interest-group",
    transform: "translate(156.000000, 297.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Regular-group-icon",
    transform: "translate(45.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0.000000, 72.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(46.250905, 10.468158)",
    fill: "#49853F"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.4328435,
    cy: 16.5623003,
    r: 16.5623003
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8002556,40.0766773 L44.0654313,40.0766773 C56.5382748,40.0766773 66.7619169,50.3003195 66.7619169,62.7731629 L66.7619169,77.086262 L0.103769968,77.086262 L0.103769968,62.7731629 C0.103769968,50.3003195 10.3274121,40.0766773 22.8002556,40.0766773 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.8402982,40.3211928 L44.1054739,40.3211928 C52.0799148,40.3211928 59.4409372,44.6151225 63.530394,51.3627263 C53.5112247,54.0208733 46.3546752,63.0176784 46.3546752,73.4457934 L46.3546752,77.5352503 L0.143812567,77.5352503 L0.143812567,63.2221512 C-0.0606602769,50.5448349 10.1629819,40.3211928 22.8402982,40.3211928 Z",
    id: "Shape",
    fill: "#FEF192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.262023,40.3211928 L136.527199,40.3211928 C149.000043,40.3211928 159.223685,50.5448349 159.223685,63.0176784 L159.223685,77.3307774 L113.012822,77.3307774 L113.012822,73.2413206 C113.012822,62.8132055 105.856273,53.8164004 95.8371033,51.1582535 C100.131033,44.4106496 107.492055,40.3211928 115.262023,40.3211928 Z",
    id: "Shape",
    fill: "#FBB040"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FEF192",
    cx: 33.472886,
    cy: 16.6023429,
    r: 16.5623003
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(109.126305, 0.000000)",
    fill: "#FBB040"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.7683067,
    cy: 16.6023429,
    r: 16.5623003
  }))))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegularGroupIcon);
export default __webpack_public_path__ + "static/media/regular-group-icon.cbd6b50f3ae940219f6dff79ece5970d.svg";
export { ForwardRef as ReactComponent };